
import {defineComponent, reactive, Ref, ref, toRefs, nextTick, watchEffect} from 'vue'

import print from 'vue3-print-nb'
import * as pdfjs from 'pdfjs-dist/build/pdf'
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

interface NoodlePrintSetupData {
  imgSrc: Ref<string>
  data: any
  modelRef: any
  tSty: Ref<boolean>
  handleCtrl: (e: MouseEvent) => void
}

export default defineComponent({
  name: 'NoodlePrint',
  props: {
    imgUrl: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  directives: {
    print,
  },
  emits: ['update:visible'],
  setup(props, {emit}): NoodlePrintSetupData {
    const {imgUrl} = toRefs(props)
    const imgSrc = ref<string>('')
    const tSty = ref<boolean>(true)
    if (imgUrl.value && imgUrl.value.hasOwnProperty('labelBase64')) {
      imgSrc.value = imgUrl.value.labelBase64
      tSty.value = true
    } else {
      imgSrc.value = imgUrl.value.fileUrl
      tSty.value = false
    }
    const state = reactive({
      pageNum: 0,
      pdfCtx: null,
    })

    const modelRef = reactive({
      checkedV: 1,
      a4V: null,
    })

    const data = reactive({
      printObj: {
        id: 'printImg',
        beforeOpenCallback (vue) {
          console.log('打开之前',vue)
        },
        closeCallback() {
          console.log('打印关闭')
        }
      },
    })

    const handleCtrl = (e: MouseEvent) => {
      emit('update:visible', false)
    }

    //显示pdf
    const resolvePdf = (url: any) => {
      let pdfObj = pdfjs.getDocument({data: atob(url)})
      pdfObj.promise.then((pdf: any) => {
        state.pdfCtx = pdf
        state.pageNum = pdf.numPages
        nextTick(() => {
          renderPdf()
        })
      })
    }
    const renderPdf = (num = 1) => {
      if (state.pdfCtx) {
        const pdfCtx = state.pdfCtx as any
        pdfCtx?.getPage(num).then((page: any) => {
          const canvas = document.getElementById(`pdf-canvas-${num}`) as any
          const ctx = canvas.getContext('2d')
          const viewport = page.getViewport({scale: 2})
          // 画布大小,默认值是width:300px,height:150px
          canvas.height = viewport.height
          canvas.width = viewport.width
          // const clientWidth = document.body.clientWidth
          // canvas.style.width = 600 + 'px'
          // 根据pdf每页的宽高比例设置canvas的高度
          // canvas.style.height = clientWidth * (viewport.height / viewport.width) + 'px'
          page.render({
            canvasContext: ctx,
            viewport,
          })
          if (num < state.pageNum) {
            renderPdf(num + 1)
          }
        })
      }
    }

    watchEffect(() => {
      if (imgSrc.value) {
        !imgSrc.value.includes('https://') ? resolvePdf(imgSrc.value) : null
      }
    })
    return {
      imgSrc,
      modelRef,
      data,
      tSty,
      ...toRefs(state),
      handleCtrl,
    }
  },
})
